<template>
  <div>
    <wc-data-box
      :title='toolbarData.title'
      :titleIcon='toolbarData.icon'
      :titleIconColor='toolbarData.color'
      :showEdit='!wo.archived && !wo.office_complete'
      @edit='editInvoicing'
    >
      <v-card-text v-if='wo.project_obj && wo.project_obj.needs_po'>
        <span v-if='!wo.po' class='error--text font-weight-bold'>P.O. is required</span>
        <span v-else class='success--text font-weight-bold'>{{"PO: " + wo.po}}</span>
      </v-card-text>
      <v-card-text>
        <v-chip label :color="wo.hold_invoice ? 'error' : 'success'">
          <v-icon v-if='wo.hold_invoice' left>{{$icons.hold.icon}}</v-icon>
          <v-icon v-else left>mdi-thumb-up</v-icon>
          <span v-if='wo.hold_invoice'>Hold Invoice</span>
          <span v-else>No Holds</span>
        </v-chip><br>
        <br>
        <span v-if='wo.hold_invoice_reason'><strong>Invoice Hold Reason:</strong> {{ wo.hold_invoice_reason }}</span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      width='400'
      :showDialog='showEditDialog'
      :title='toolbarData.title'
      :icon='toolbarData.icon'
      :iconColor='toolbarData.color'
      @cancel='showEditDialog = false'
      @save='update'
    >
      <v-form ref='invoiceForm'>
        <v-text-field
          outlined
          :label='wo.po ? "Edit PO" : "Add PO"'
          v-model='woCopy.po'
          @input='setHoldBoolean'
        ></v-text-field>
        <br>
        <v-checkbox
          v-model='woCopy.hold_invoice'
          label='Put invoice on hold?'
          :hint="woCopy.hold_invoice ? 'Clear reason to remove hold' : 'Add reason to hold invoice'"
          persistent-hint
          readonly
        ></v-checkbox>
        <br>
        <v-text-field
          outlined
          label='Hold reason'
          v-model='woCopy.hold_invoice_reason'
          @input='setHoldBoolean'
          :rules='woCopy.hold_invoice ? [rules.required] : []'
        ></v-text-field>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'field-instructions',
  mixins: [formRules],
  props: {
    wo: {
      required: true
    }
  },
  data: () => ({
    showEditDialog: false,
    woCopy: ''
  }),
  computed: {
    toolbarData () {
      return {
        title: 'Invoicing',
        icon: 'mdi-receipt',
        color: 'success'
      }
    }
  },
  methods: {
    editInvoicing () {
      this.woCopy = _.cloneDeep(this.wo)
      this.showEditDialog = true
    },
    update () {
      if (this.$refs.invoiceForm && !this.$refs.invoiceForm.validate()) {
        return
      }
      this.$emit('update', this.woCopy)
      this.showEditDialog = false
    },
    setHoldBoolean () {
      const hasPO = !!(this.woCopy.po && this.woCopy.po.trim() !== '')
      const hasReason = !!(this.woCopy.hold_invoice_reason && this.woCopy.hold_invoice_reason.trim() !== '')
      this.woCopy.hold_invoice = hasPO || hasReason
    }
  }
}
</script>
